import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MagArtCriticitaModel, MagazziniArticoliCriticita } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniArticoliCriticitaService extends CrudGenericsService<MagazziniArticoliCriticita, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniArticoliCriticita`);
    this.base = `${env.apiUrl}/api/MagazziniArticoliCriticita/`;
  }

  GetCriticita_byArt(id: number): Observable<MagArtCriticitaModel[]> {
    const u = `${this.base}GetCriticita_byArt?id=${id}`;
    return this.http.get<MagArtCriticitaModel[]>(u);
  }
  GetCriticita_byMagArt(id: number): Observable<MagArtCriticitaModel> {
    const u = `${this.base}GetCriticita_byMagArt?id=${id}`;
    return this.http.get<MagArtCriticitaModel>(u);
  }
}
